import { useLocation, useNavigate } from 'react-router-dom'
import { pathWithoutLocale, localePath as buildLocalePath } from '../i18n/routes'
import { useLocale } from '../i18n/LocaleContext'

export function LocaleSwitch() {
  const { locale, setLocale, t } = useLocale()
  const navigate = useNavigate()
  const location = useLocation()

  const switchTo = (next) => {
    if (next === locale) return
    setLocale(next)
    const bare = pathWithoutLocale(location.pathname)
    navigate(buildLocalePath(next, bare) + location.search, { replace: true })
  }

  return (
    <div className="locale-switch" role="group" aria-label={t.language}>
      <button
        type="button"
        className={locale === 'it' ? 'active' : ''}
        onClick={() => switchTo('it')}
      >
        IT
      </button>
      <button
        type="button"
        className={locale === 'en' ? 'active' : ''}
        onClick={() => switchTo('en')}
      >
        EN
      </button>
    </div>
  )
}
